module.exports = __webpack_public_path__ + "img/HomePage-insurance.9325fee.webp";